function trueType(data) {
  return Object.prototype.toString.call(data).slice(8, -1).toLowerCase();
}
function isType(data, type) {
  const typeOfType = trueType(type);
  return trueType(data) === (typeOfType === "string" ? type : typeOfType);
}
export { isType, trueType };
